var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"swiper"},[_c('top-swipe')],1),_c('div',{staticClass:"top1"},[_c('top-one-vue')],1),_c('div',{staticClass:"top2"},[_c('top-two')],1),_c('div',{staticClass:"top3"},[_c('top-three-vue')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }